<div class="container">
  <ng-container *ngIf="!isLoading">
    <div class="card" *ngFor="let card of cards">
      <h2>
        {{ card.title }}
        <span
          *ngFor="let flag of card.flagValues"
          class="flag {{ flag.color }}"
        >
          {{ flag.val }}%
        </span>
      </h2>
      <span class="hcp-count"
        >Total number of HCPs: {{ card.totalVendors | number: "1.0-0" }}</span
      >
      <h3>{{ card.subTitle }}</h3>
      <table>
        <tr>
          <th>Health Care Professional</th>
          <th>HCP Country</th>
          <th>Market</th>
          <th>Region</th>
          <th>Total Spend USD</th>
        </tr>
        <tr *ngFor="let vendor of card.data">
          <td>{{ vendor.vendor_name }}</td>
          <td>{{ vendor.vendor_country }}</td>
          <td>{{ vendor.market }}</td>
          <td>{{ vendor.region }}</td>
          <td>{{ vendor.total_spend_usd | currency: "USD" }}</td>
        </tr>
      </table>
    </div>
  </ng-container>
  <ng-container *ngIf="isLoading">
    <app-spinner
      [display]="true"
      [class]="'spinner-container'"
      [messageToDisplay]="'Loading HCP data...'"
    ></app-spinner>
  </ng-container>
</div>
